import { createApi } from '@reduxjs/toolkit/query/react'
import { baseQueryWithHttpStatus } from '../services/baseQuery';

// Define a service using a base URL and expected endpoints
export const agentStore = createApi({
    reducerPath: 'agentStore',
    baseQuery: baseQueryWithHttpStatus,
    endpoints: (builder) => ({
        createAgentInstance: builder.mutation({
            query: (body) => {
                return {
                    url: "gptBlueAgentExecute/createAgentInstance/",
                    method: "POST",
                    body: { ...body }
                }
            },
        }),
    }),
})

export const {
    useCreateAgentInstanceMutation,
} = agentStore;